import styled, { css } from 'styled-components';

export const Container = styled.label(
  () => css`
    position: relative;
    display: inline-block;
  `,
);

export const Input = styled.input.attrs({ type: 'checkbox' })(
  () => css`
    opacity: 0;
    width: 0;
    height: 0;
    position: absolute;
  `,
);

export const Slider = styled.div(
  ({ theme }) => css`
    cursor: pointer;
    background-color: ${theme.co.neutral90};
    border-radius: ${theme.bo.round};
    transition:
      padding 0.2s,
      background-color 0.2s;
    padding-right: ${theme.sz.s4};

    &::before {
      content: '';
      display: block;
      box-sizing: border-box;
      border-radius: ${theme.bo.round};
      height: ${theme.sz.s8};
      width: ${theme.sz.s8};
      border: ${theme.bo.mediumWidth} solid transparent;
      background-color: ${theme.co.neutral99};
      background-clip: content-box;
      box-shadow: ${theme.sh.s2};
    }

    input:disabled + & {
      background-color: ${theme.co.neutral95};
      cursor: not-allowed;
      &::before {
        box-shadow: unset;
      }
    }

    input:checked + & {
      background-color: ${theme.co.success80};
      padding-right: 0;
      padding-left: ${theme.sz.s4};
    }

    input:checked:disabled + & {
      background-color: ${theme.co.success95};
    }

    input:focus-visible + & {
      // Same as global override
      box-shadow: 0 0 0 3px ${theme.co.information50};
    }
  `,
);
